
export { JobExecutionDetails } from "/codebuild/output/src4243307676/src/actions-runner/_work/eon-service/eon-service/frontend/packages/api-gw-sdk/dist/models/JobExecutionDetails.js"